<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <button
        type="button"
        :class="['month-btn', { 'month-btn--compact': compact }, 'text-uppercase']"
        v-bind="attrs"
        v-on="on"
      >
        {{ label }}
      </button>
    </template>
    <v-date-picker
      :value="value"
      type="month"
      no-title
      scrollable
      @input="$emit('input', $event)"
    >
      <v-spacer />
      <v-btn small color="error" @click="menu = false">Fechar</v-btn>
      <v-btn small color="success" @click="confirm">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'MonthPicker',
  props: {
    value: { type: String, required: true },
    label: { type: String, required: true },
    compact: { type: Boolean, default: false },
  },
  data() {
    return { menu: false }
  },
  methods: {
    confirm() {
      this.menu = false
      this.$emit('input', this.value)
    },
  },
}
</script>

<style scoped>
.month-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #37474f;
  letter-spacing: 0.5px;
  min-width: 110px;
  text-align: center;
  padding: 4px 8px;
}
.month-btn--compact {
  font-size: 12px;
  min-width: 96px;
  flex: 1;
}
</style>
